<template>
  <div class="control">
    <div class="control__buttons">
      <button
        :disabled="disableBack"
        class="btn btn--secondary btn--ghost"
        @click="$emit('back')"
      >
        <svg
          aria-hidden="true"
          class="btn-icon btn-icon--left"
          role="img"
        >
          <use xlink:href="#arrow-right" />
        </svg>
        {{ backButtonLabel }}
      </button>
      <button
        v-show="showNext"
        class="btn btn--primary"
        @click="$emit('next')"
      >
        {{ nextButtonText }}
        <svg
          aria-hidden="true"
          class="btn-icon"
          role="img"
        >
          <use xlink:href="#arrow-right" />
        </svg>
      </button>
    </div>
    <div aria-live="polite">
      <div
        v-if="requiredError"
        class="control__error"
      >
        {{ requiredFieldErrorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { selectionTypeMultiSelect } from '../constants';
  export default {
    name: 'Control',
    props: {
      backButtonLabel: {
        type: String,
        required: true
      },
      finalButtonLabel: {
        type: String,
        required: true
      },
      nextButtonLabel: {
        type: String,
        required: true
      },
      requiredFieldErrorMessage: {
        type: String,
        required: true
      },
      disableBack: {
        type: Boolean,
        required: false
      },
      disableNext: {
        type: Boolean,
        required: false
      },
      requiredError: {
        type: Boolean,
        required: false
      },
    },
    computed: {
      ...mapGetters('skincareV2Store', [
        'activeQuestion',
        'final'
      ]),
      showNext() {
        return !this.disableNext || this.activeQuestion.type === selectionTypeMultiSelect || this.final;
      },
      nextButtonText() {
        return this.final ? this.finalButtonLabel : this.nextButtonLabel;
      }
    }
  };
</script>

<style lang="scss" scoped>
.btn {
  align-items: center;
  display: inline-flex;
  gap: rem(8px);
  justify-content: center;
  max-width: calc(50% - #{rem(8px)});

   @include media('<=small2x') {
     flex: 1;
     min-width: unset;
   }

   &[disabled] {
     pointer-events: none;
   }
}

.btn-icon {
  height: rem(13px);
  width: rem(7px);

  &--left {
    transform: rotate(180deg);
  }
}

.control {
  &__buttons {
    display: flex;
    gap: rem(22px);
    justify-content: space-between;
    width: 100%;

    @include for('large') {
      margin: 0 auto;
      max-width: rem(1024px);
    }
  }

  &__error {
    color: var(--mcb-quiz-control-error-text-color);
    font-size: rem(12px);
    line-height: rem(16.34px);
    margin: rem(20px) auto;
    max-width: rem(1024px);
    text-align: right;
  }
}
</style>
